import styled from "@emotion/styled";
import { Button } from "@mui/material";

const BootstrapButton = styled(Button)({
  textTransform: "none",
  fontSize: 16,
  padding: "6px 12px",
  border: "1px solid",
  lineHeight: 2,
  minHeight: "34px",
  backgroundColor: "#FC4C4C",
  borderColor: "#FC4C4C",
  color: "#fff",
  boxShadow: "0px 4px 4px rgba(215, 192, 192, 0.5)",
  borderRadius: "10px",
  width: "100%",

  "&:hover": {
    backgroundColor: "#FEDBDB",
    borderColor: "#FEDBDB",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#FEDBDB",
    borderColor: "#FEDBDB",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem #FEDBDB",
  },
});

export default BootstrapButton;
